import { TextStyles } from '../../types';

export const globalStyles = {
  body: {
    bg: 'surface-page',
  },
  a: {
    color: 'text-interactive',
    fontWeight: 'link',
    textDecoration: 'underline',
    _hover: {
      textDecoration: 'underline',
    },
  },
  h1: {
    apply: `textStyles.${TextStyles.H1}`,
    color: 'text-emphasis',
  },
  h2: {
    apply: `textStyles.${TextStyles.H2}`,
    color: 'text-emphasis',
  },
  h3: {
    apply: `textStyles.${TextStyles.H3}`,
    color: 'text-emphasis',
  },
  h4: {
    apply: `textStyles.${TextStyles.H4}`,
    color: 'text-emphasis',
  },
  h5: {
    apply: `textStyles.${TextStyles.H5}`,
    color: 'text-emphasis',
  },
  h6: {
    apply: `textStyles.${TextStyles.H6}`,
    color: 'text-emphasis',
  },
};
